<div id="layout">

    <mat-sidenav-container dir="ltr" fxFlexFill>

        <clearcals-header *ngIf="!isHintApp" [leftSidenavOpen]="leftSidenavOpen" [currentSection]="currentSection"
            (toggleSidenav)="toggleSidenav($event)"></clearcals-header>

        <div class="container">
            <router-outlet></router-outlet>
        </div>

        <clearcals-footer></clearcals-footer>

        <clearcals-scroll-top></clearcals-scroll-top>

        <clearcals-cookie-policy *ngIf="!isHintApp"></clearcals-cookie-policy>

        <mat-sidenav [mode]="leftSidenavMode" [(opened)]="leftSidenavOpen" class="header-sidenav" #leftSidenav>

            <a class="logo mt-16" href="/">
                <img src="https://img.clearcals.com/site/images/hint/logo_round.svg" alt="Clearcals">
                <h3 class="heading-3 title-text">Clearcals</h3>
            </a>

            <ul class="header-content">
                <li [ngClass]="{'active': currentSection == '/'}" (click)="navigate('/')">
                    <a href="javascript: void(0);">Home</a>
                </li>
                <li [ngClass]="{'active': currentSection == '/store/garmin-watches'}"
                    (click)="navigate('store/garmin-watches')">
                    <a href="javascript: void(0);">Store</a>
                </li>
                <li [ngClass]="{'active': currentSection === '/products/hint'}" (click)="navigate('products/hint')">
                    <a href="javascript: void(0);">Hint</a>
                </li>
                <li [ngClass]="{'active': currentSection === '/products/expert'}" (click)="navigate('products/expert')">
                    <a href="javascript: void(0);">Expert</a>
                </li>
                <li [ngClass]="{'active': currentSection === '/resources'}" (click)="navigate('resources')">
                    <a href="javascript: void(0);">Resources</a>
                </li>
                <li [ngClass]="{'active': currentSection === '/blogs'}" (click)="navigate('blogs')">
                    <a href="javascript: void(0);">Blogs</a>
                </li>
                <li [ngClass]="{'active': currentSection === '/web-stories'}" (click)="navigate('web-stories')">
                    <a href="javascript: void(0);">Web Stories</a>
                </li>
                <li [ngClass]="{'active': currentSection === 'contact'}" (click)="navigate('contact')">
                    <a href="javascript: void(0);">Contact</a>
                </li>
            </ul>

            <button mat-raised-button color="primary" aria-label="Download"
                (click)="openLink('https://play.google.com/store/apps/details?id=com.clearcals.hint')">
                Download
            </button>
        </mat-sidenav>

    </mat-sidenav-container>

</div>